import { DEFAULT_DATA_CHUNK_BYTES, DEFAULT_METADATA_CHUNK_BYTES } from "../../protocol";
import type { TransferLimits } from "../../packaging";

export interface TransferEstimate {
  estimatedFrames: number;
  estimatedSeconds: number;
  state: "normal" | "long";
}

export function estimateUnpreparedTransfer(
  sourceBytes: number,
  fileCount: number,
  frameDurationMs: number,
  limits: TransferLimits,
): TransferEstimate {
  const estimatedManifestBytes = 220 + fileCount * 480;
  const estimatedPackageBytes = sourceBytes + estimatedManifestBytes + 12;
  const dataFrames = Math.max(
    1,
    Math.ceil(estimatedPackageBytes / DEFAULT_DATA_CHUNK_BYTES),
  );
  const metadataFrames = Math.max(1, Math.ceil(180 / DEFAULT_METADATA_CHUNK_BYTES));
  return estimatePreparedTransfer(dataFrames + metadataFrames, frameDurationMs, limits);
}

export function estimatePreparedTransfer(
  frameCount: number,
  frameDurationMs: number,
  limits: TransferLimits,
): TransferEstimate {
  const estimatedSeconds = Math.ceil((frameCount * frameDurationMs) / 1_000);
  return {
    estimatedFrames: frameCount,
    estimatedSeconds,
    state: estimatedSeconds >= limits.warnEstimatedSeconds ? "long" : "normal",
  };
}

export function formatDuration(seconds: number): string {
  if (seconds < 60) {
    const displayedSeconds = Math.max(1, seconds);
    return `about ${displayedSeconds.toString()} ${
      displayedSeconds === 1 ? "second" : "seconds"
    } per loop`;
  }
  const minutes = Math.ceil(seconds / 60);
  return `about ${minutes.toString()} ${minutes === 1 ? "minute" : "minutes"} per loop`;
}
